import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

export const useQueryUnreadCount = (enabled = true) => {
	return useQuery({
		queryKey: chatKeys.unreadCount(),
		queryFn: () => chatService.getUnreadCount(),
		enabled,
		refetchOnMount: true,
		staleTime: 30 * 1000, // 30 seconds
	})
}
